import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { useStyles } from '../../styles';

interface StopRunDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  executionMode?: string;
}

export const StopRunDialog = ({
  open,
  onCancel,
  onConfirm,
  executionMode,
}: StopRunDialogProps) => {
  const classes = useStyles();

  const bodyText =
    executionMode === 'execute'
      ? 'If you stop this run, it will stop before results are generated. You can run again to see results.'
      : executionMode === 'enhance'
      ? 'If you stop this run, test cases being generated in this run will not be saved.  Existing test cases will remain unchanged.'
      : 'If you stop this run, test cases being generated in this run will not be saved. Any existing test cases will remain unchanged.';

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="stop-run-dialog-title"
      maxWidth="sm"
      fullWidth
      PaperProps={{ className: classes.stopRunDialogPaper }}
    >
      <DialogTitle id="stop-run-dialog-title" disableTypography>
        <Typography variant="h6" className="ec-stop-dialog-title">
          Stop this run?
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography className="ec-stop-dialog-body">{bodyText}</Typography>
      </DialogContent>

      <DialogActions className="ec-stop-dialog-actions">
        <Button
          onClick={onCancel}
          variant="outlined"
          aria-label="Continue Run"
          className="ec-stop-dialog-cancel"
        >
          Continue Run
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          aria-label="Stop Run"
          className="ec-stop-dialog-confirm"
        >
          Stop Run
        </Button>
      </DialogActions>
    </Dialog>
  );
};
